import React from 'react';
import { Link } from 'react-router-dom';
import '../scss/whatsapp-edevcode.scss';

export default function WhatsAppEdevcodeTerms() {
  return (
    <main className="wec-legal-page">
      <div className="wec-legal-container">
        <Link className="wec-back-link" to="/whatsapp">
          Voltar para /whatsapp
        </Link>

        <h1>Termos de Serviço</h1>
        <p>
          Estes Termos de Serviço regulam a contratação dos serviços prestados
          por 54.240.100 EMERSON DE FARIAS SANTOS (eDevCode), CNPJ
          54.240.100/0001-14, relacionados à implantação e operação da API
          oficial do WhatsApp para envio de mensagens e atendimento.
        </p>

        <h2>1. Objeto</h2>
        <p>
          Prestação de serviços técnicos para configuração, integração,
          manutenção e suporte de operações empresariais no WhatsApp Business
          Platform.
        </p>

        <h2>2. Condições de uso</h2>
        <ul>
          <li>
            O cliente deve fornecer informações corretas e manter responsáveis
            técnicos/comerciais para execução do projeto.
          </li>
          <li>
            O cliente é responsável pelo conteúdo das mensagens enviadas e por
            sua base de contatos.
          </li>
          <li>
            É obrigatório respeitar as políticas da Meta e as normas legais
            aplicáveis.
          </li>
        </ul>

        <h2>3. Política anti-spam e conformidade</h2>
        <p>
          É proibido utilizar a estrutura para envio de mensagens não
          autorizadas, comunicações abusivas ou conteúdo ilícito. O
          descumprimento pode gerar suspensão imediata do serviço.
        </p>

        <h2>4. Planos, preços e pagamentos</h2>
        <ul>
          <li>
            Os valores variam conforme plano contratado, volume de mensagens e
            necessidades de integração.
          </li>
          <li>
            Custos de terceiros (como cobrança oficial de mensagens da Meta)
            podem ser repassados conforme contrato comercial.
          </li>
          <li>
            O não pagamento pode acarretar bloqueio, suspensão ou cancelamento
            da operação.
          </li>
        </ul>

        <h2>5. Níveis de serviço e suporte</h2>
        <p>
          O suporte será prestado conforme escopo contratado, canais definidos e
          horários de atendimento acordados na proposta comercial.
        </p>

        <h2>6. Propriedade intelectual</h2>
        <p>
          Scripts, fluxos, integrações e ativos técnicos desenvolvidos pela
          eDevCode permanecem protegidos por direitos autorais e legislação
          aplicável, salvo disposição contratual específica.
        </p>

        <h2>7. Limitação de responsabilidade</h2>
        <p>
          A eDevCode não se responsabiliza por indisponibilidades causadas por
          terceiros, por bloqueios decorrentes de violação das políticas da Meta
          pelo cliente, nem por decisões comerciais tomadas com base exclusiva
          em métricas operacionais.
        </p>

        <h2>8. Privacidade e proteção de dados</h2>
        <p>
          O tratamento de dados pessoais ocorre conforme a Política de
          Privacidade e a legislação de proteção de dados aplicável.
        </p>

        <h2>9. Rescisão</h2>
        <p>
          Qualquer parte pode solicitar rescisão conforme prazos e regras
          previstos na proposta comercial ou instrumento contratual assinado.
        </p>

        <h2>10. Foro e legislação</h2>
        <p>
          Estes termos são regidos pela legislação brasileira. Fica eleito o
          foro da comarca de João Pessoa/PB para dirimir controvérsias, salvo
          disposição legal em contrário.
        </p>

        <h2>11. Data de vigência</h2>
        <p>Última atualização: 12 de abril de 2026.</p>
      </div>
    </main>
  );
}
